import React from 'react';
import { Link } from 'react-scroll';
import { FiGithub, FiMail } from 'react-icons/fi';
import { FaLinkedinIn } from 'react-icons/fa';
import ScrollGrid from './ScrollGrid';
import './Footer.css';

const Footer = () => {
  const navLinks = [
    { label: 'Home', to: 'hero' },
    { label: 'About', to: 'about' },
    { label: 'Experience', to: 'experience' },
    { label: 'Skills', to: 'skills' },
    { label: 'Education', to: 'education' },
    { label: 'Contact', to: 'contact' },
  ];

  return (
    <footer className="footer">
      <ScrollGrid fadeVariant="fade-bottom" />
      <div className="container">
        <div className="footer-main">
          <div className="footer-brand">
            
            <div>
              <h3>Jay Marc C. Merilo</h3>
              <p>UI/UX Designer &amp; Developer</p>
            </div>
          </div>

          <nav className="footer-nav">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                smooth={true}
                duration={500}
                offset={-80}
                className="footer-nav-link clickable"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="footer-socials">
            <a href="https://github.com/emarcj0-debug" target="_blank" rel="noopener noreferrer" className="footer-social clickable" aria-label="GitHub">
              <FiGithub />
            </a>
            <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="footer-social clickable" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="mailto:jaymarccmerilo@gmail.com" className="footer-social clickable" aria-label="Email">
              <FiMail />
            </a>
          </div>
        </div>

        <div className="footer-divider" />

        
      </div>
    </footer>
  );
};

export default Footer;
